import { createFileRoute, redirect } from "@tanstack/react-router";

import { PRESENTER_DEBUG_PATH } from "~/routes/-route-constants/appRoutes.ts";

/** The dev section has no page of its own. It opens on the presenter debug view. */
export const Route = createFileRoute("/_auth/dev/")({
    beforeLoad: () => {
        throw redirect({ to: PRESENTER_DEBUG_PATH });
    },
});
